module.exports = {"130108001":"裕兴街道","130108002":"裕强街道","130108003":"东苑街道","130108004":"建通街道","130108005":"槐底街道","130108006":"裕华路街道","130108007":"裕东街道","130108008":"裕翔街道","130108009":"建华南街道","130108101":"方村镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130108.json
// module id = 146
// module chunks = 0